// assumed to be in "px"
export var SIZE_SUB_UNIT = 4;
export var SIZE_UNIT = 8;
export var GUTTER_HEIGHT = 8;
